const menuMain = {
    init() {

    }

}

export {menuMain}